import React, { useState } from 'react';
import { AiOutlineCloudDownload } from 'react-icons/ai';
import { IoIosArrowBack } from 'react-icons/io';
import LazyLoad from 'react-lazyload';
import { pdfjs, Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import Loader from '../../../common/Loader';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type Props = {
    fileObject: string;
    fileName: string;
    redirectToDealDetails: () => void;
    isDownloadable: boolean;
    onDownload: () => void;
};

const PDFLazyLoading: React.FC<Props> = ({
    fileObject,
    fileName,
    redirectToDealDetails,
    isDownloadable,
    onDownload,
}) => {
    const [numPages, setNumPages] = useState<number>(0);

    const onDocumentLoadSuccess = (pdfProps: any) => {
        setNumPages(pdfProps.numPages);
    };

    return (
        <div className="max-w-4xl overflow-hidden m-auto relative">
            <Document
                file={fileObject}
                onLoadSuccess={onDocumentLoadSuccess}
                options={{
                    cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
                    cMapPacked: true,
                }}
            >
                <div className="fixed " style={{ top: 80, width: 880, backgroundColor: '#f0f2f5', zIndex: 1 }}>
                    <div className="flex justify-between py-4 items-center">
                        <div className="flex items-center">
                            <IoIosArrowBack
                                className="cursor-pointer mr-2"
                                size="1.4rem"
                                color="#c49a6d"
                                onClick={redirectToDealDetails}
                            />
                            <p className="text-lg SourceSansPro-Bold" style={{ color: '#16365c' }}>
                                {fileName}
                            </p>
                        </div>
                        {isDownloadable && (
                            <div>
                                <AiOutlineCloudDownload
                                    size="1.6rem"
                                    className="cursor-pointer"
                                    color="#c49a6d"
                                    onClick={onDownload}
                                />
                            </div>
                        )}
                    </div>
                </div>
                {new Array(numPages).fill('').map((_x, index) => (
                    <LazyLoad placeholder={<Loader />} key={`lazy_loading_${index}_pdf`}>
                        <Page
                            pageIndex={index}
                            renderMode="canvas"
                            className="document_page"
                            loading={<Loader />}
                            renderAnnotationLayer={false}
                            width={880}
                        />
                    </LazyLoad>
                ))}
            </Document>
        </div>
    );
};

export default PDFLazyLoading;
